import React from 'react'
import ContactUs from './ContactUs';
import Breadcrumb from './Breadcrumb';

function ContactPage() {
    return ( 
        <>
        <Breadcrumb />
        <ContactUs />
       
        </>
     );
}

export default ContactPage;